import type { TextBox } from "store/features/memeGenerator/types";
import { LetterSpacing } from "./LetterSpacing/LetterSpacing";
import { LineSpacing } from "./LineSpacing/LineSpacing";

export interface FontSpcingOptionsProps {
    textBox: TextBox;
}

export const FontSpacingOptions = ({ textBox }: FontSpcingOptionsProps) => {
    return (
        <div className="absolute top-full translate-y-2 left-0 bg-white dark:bg-darkSurface-200 border-[0.5px] border-[#DCDDDF] dark:border-darkSurface-100 rounded-xl p-6 flex flex-col gap-10 w-[260px]">
            <LetterSpacing textBox={textBox} />
            <LineSpacing textBox={textBox} />
        </div>
    );
};
